import { UltramarineBlue } from '@core/theme/baseTheme';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import { styled } from '@mui/material/styles';

export const MoreInfoIcon = styled(InfoIcon)`
	width: 20px;
	height: 20px;
	color: ${UltramarineBlue}
`;
